// Web registers no push device at all. The browser build reads the persisted notification and the
// unread badge over REST, and the backend is written for a user who has no device rows, so the
// honest web implementation of this seam is to do nothing rather than to half-support the Web Push
// transport. Every export mirrors the native module so callers never branch on the platform.

export async function registerPushDevice(_locale: string): Promise<void> {
    // Intentionally empty — see the file comment.
}

export async function unregisterPushDevice(): Promise<void> {
    // Intentionally empty — nothing was ever registered to release.
}

export function addPushTokenRotationListener(_onRotate: () => void): () => void {
    return () => {
        // Nothing was subscribed.
    };
}
